import type React from 'react';

export interface OrdersIconProps {
	width?: string | number;
	height?: string | number;
	color?: string;
	'aria-label'?: string;
}

const OrdersIcon: React.FC<OrdersIconProps> = ({
	width = 25,
	height = 25,
	color = 'currentColor',
	'aria-label': ariaLabel = 'Orders Icon',
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 25 25"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-label={ariaLabel}
		style={{ color }}
	>
		<path
			d="M14.3084 12.3098L12.2997 14.3187L11.5019 13.5211C11.2816 13.3008 10.9245 13.3008 10.7043 13.5211C10.484 13.7414 10.484 14.0984 10.7043 14.3187L11.9009 15.5154C12.0067 15.6211 12.1503 15.6806 12.2997 15.6806C12.4492 15.6806 12.5928 15.6211 12.6985 15.5154L15.106 13.1074C15.3262 12.8871 15.3262 12.53 15.106 12.3095C14.8857 12.0895 14.5289 12.0895 14.3084 12.3098Z"
			fill="currentColor"
		/>
		<path
			d="M19.4903 17.7724L18.6682 9.5517C18.5192 8.06284 17.2783 6.94007 15.7824 6.94007H15.3362V6.63603C15.3362 5.94251 15.066 5.29045 14.5756 4.79943C14.0845 4.30925 13.4325 4.03906 12.7387 4.03906C12.0454 4.03906 11.3931 4.30925 10.9026 4.79943C10.4125 5.2896 10.1423 5.94166 10.1423 6.63547V6.94007H9.69609C8.19962 6.94007 6.95895 8.06284 6.81032 9.5517L5.9879 17.7724C5.90668 18.5864 6.17489 19.4006 6.72345 20.007C7.27229 20.6134 8.05606 20.9611 8.87396 20.9611H16.6042C17.4221 20.9611 18.2059 20.6134 18.7542 20.0073C19.303 19.4012 19.5715 18.5867 19.4903 17.7724ZM11.2704 6.63547C11.2704 6.24316 11.423 5.87454 11.7002 5.5973C11.9777 5.32006 12.3466 5.1672 12.739 5.1672C13.1313 5.1672 13.5002 5.32006 13.7777 5.5973C14.0549 5.87482 14.2078 6.24372 14.2078 6.63603V6.94007H11.2704V6.63547ZM17.9177 19.25C17.5829 19.6206 17.104 19.833 16.6042 19.833H8.87396C8.37448 19.833 7.8953 19.6206 7.55996 19.25C7.22491 18.8797 7.06104 18.3819 7.11068 17.885L7.93281 9.66423C8.02363 8.75439 8.78173 8.06848 9.69609 8.06848H10.1423V8.72224C10.1423 9.0336 10.395 9.28631 10.7063 9.28631C11.0177 9.28631 11.2704 9.0336 11.2704 8.72224V8.06848H14.2078V8.72224C14.2078 9.0336 14.4605 9.28631 14.7719 9.28631C15.0832 9.28631 15.3359 9.0336 15.3359 8.72224V8.06848H15.7821C16.6962 8.06848 17.4546 8.75467 17.5454 9.66423L18.3675 17.8847C18.4171 18.3819 18.2533 18.8797 17.9177 19.25Z"
			fill="currentColor"
		/>
	</svg>
);

export default OrdersIcon;
